





















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { DashboardService } from "@/services/dashboard.service";

@Component({
})
export default class ErrosCardSuporte extends Vue {
  totalErros: number | null = null;
  loadingErros = false;

  mounted() {
    this.CarregarQuantidadeErros();
  }

  async CarregarQuantidadeErros() {
    this.loadingErros = true;
    this.totalErros = await DashboardService.QuantidadeErros().finally(
      () => (this.loadingErros = false)
    );
  }
}
